export enum SortDirection {
  ascending = 'asc',
  descending = 'desc'
}
